import { Pipe, PipeTransform } from '@angular/core';
import * as emoji from 'node-emoji';

@Pipe({
  name: 'unemojis'
})
export class UnemojisPipe implements PipeTransform {

  transform(str: string): string {
    return str ? emoji.emojify(str) : str;
  }

}
